/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import {
    getLayoutSectionByKey,
    type LayoutSectionKey,
} from '@/config/layoutSections';

interface LayoutSectionHeaderProps {
    description?: string;
    sectionKey: LayoutSectionKey;
}

function LayoutSectionHeader({ description, sectionKey }: LayoutSectionHeaderProps) {
    const section = getLayoutSectionByKey(sectionKey);

    if (!section) {
        return null;
    }

    return (
        <section className="layouts-section">
            <div className="flex flex-wrap items-start gap-3">
                <h2 className="mb-0 text-2xl font-semibold">{section.label}</h2>
                <span className={`badge ${section.badgeClassName}`}>
                    {section.badgeLabel}
                </span>
            </div>
            <p className="text-base-content/70">
                {description ?? section.description}
            </p>
        </section>
    );
}

export default LayoutSectionHeader;
